import React, { useState, useEffect } from "react";
import MenuBar from "../../components/atoms/menuBar/MenuBar";
import { SERVICES_PATH } from "../../router/Routes";
import "./services.css";
import { ServicesContainer } from "../../components/atoms/containers/Containers";
import { getServices } from "../../services";
import { BaseButton } from "../../components/atoms/buttons/Buttons";

const Services = () => {
  useEffect(() => {
    document.title = "Aglocol | Servicios";
  }, []);

  const [services, setServices] = useState([]);

  const [activeServiceTitle, setActiveServiceTitle] = useState("");
  const [activeServiceDescription, setActiveServiceDescription] = useState("");
  const [selectedService, setSelectedService] = useState(-1);
  const [activeServiceImage, setActiveServiceImage] = useState(null);
  const [activeButton, setActiveButton] = useState("");

  const changeActiveService = (services, index) => {
    setActiveServiceTitle(services[index].service);
    setActiveServiceDescription(services[index].description);
    setActiveServiceImage(services[index].image);
    setActiveButton(services[index].video);
    setSelectedService(index);
  };

  useEffect(() => {
    getServices().then((result) => {
      setServices(result);
      changeActiveService(result, 0);
    });
  }, []);

  return (
    <div className="main-container services-background">
      <MenuBar view={SERVICES_PATH} />
      <div className="view-content">
        <div className="services-main-container flex-order">
          <div className="services-left-container">
            <div className="active-service-title">{activeServiceTitle}</div>
            <img
              src={activeServiceImage}
              className="active-service-image"
              alt={activeServiceTitle}
            />
            <div
              className={`active-service-description ${
                selectedService !== -1 ? "description-no-bold" : ""
              }`}
            >
              {activeServiceDescription}
            </div>
            {activeButton && (
              <BaseButton
                text="Ver video"
                callback={() => window.open(activeButton)}
              />
            )}
          </div>
          <div className="services-right-container">
            {services.map((service, index) => (
              <ServicesContainer
                text={service.service}
                callback={() => changeActiveService(services, index)}
                active={selectedService === index}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
